const firebaseConfig = {
    apiKey: "AIzaSyDe6hyjxDRm8kWcsGgYKEwncxD-kP033CM",
    authDomain: "final-assignment-99332.firebaseapp.com",
    projectId: "final-assignment-99332",
    storageBucket: "final-assignment-99332.appspot.com",
    messagingSenderId: "127217744711",
    appId: "1:127217744711:web:bd29068ff7ebf2a8926a62"
};
export default firebaseConfig;